import { FC } from 'react';

import Page from '@/components/Page.tsx';

const FeedPage: FC = () => {
    // eslint-disable-next-line i18next/no-literal-string
    return <Page fullScreen>Feed Page</Page>;
};

export default FeedPage;
